import React, { forwardRef } from 'react'
import './checkbox.styles.css'
import { cn } from 'components/UI/cn'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  boxSize?: 'sm' | 'md' | 'lg'
  wrapperClassName?: string
  indeterminate?: boolean
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (props, forwardedRef) => {
    const { wrapperClassName, boxSize, indeterminate, ...rest } = props

    const setRef = React.useCallback(
      (node: HTMLInputElement | null) => {
        if (node && typeof indeterminate === 'boolean') {
          node.indeterminate = !rest.checked && indeterminate
        }
        if (typeof forwardedRef === 'function') {
          forwardedRef(node)
        } else if (forwardedRef) {
          forwardedRef.current = node
        }
      },
      [forwardedRef, indeterminate, rest.checked]
    )

    return (
      <label
        className={cn('custom-checkbox ', wrapperClassName, {
          'cursor-pointer': !rest.disabled,
        })}
      >
        <input type="checkbox" {...rest} ref={setRef} />
        <span className={`checkmark checkmark-${boxSize ?? 'md'} `}></span>
      </label>
    )
  }
)
Checkbox.displayName = 'Checkbox'

export default Checkbox
